import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ProviderInvoiceForm from "@components/forms/ProviderInvoiceForm";

const ProviderInvoiceAddEdit = () => {
  const params = useParams()
  const { id: providerInvoiceId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!providerInvoiceId ? 'Agregar' : 'Editar'} Factura de Provedor`}
      backUrl="/user/provider-invoices"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "providerInvoiceForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ProviderInvoiceForm
        formId="providerInvoiceForm"
        id={providerInvoiceId}
        saveRedirectUrl="/user/provider-invoices"
      ></ProviderInvoiceForm>

    </PageContainer>
  );
}

export default ProviderInvoiceAddEdit;
